import { ContentContainer } from '@/components/ui/content-container.component';
import { Skeleton } from '@/components/ui/skeleton.component';

export const NearbyBranchesSectionLoading = () => {
  return (
    <>
      <ContentContainer className="flex md:hidden flex-col gap-6">
        {Array.from({ length: 5 }).map((_, index) => {
          return (
            <div key={`branch-near-you-${index}`} className="flex flex-col gap-4 py-5">
              <div className="w-full flex gap-4">
                <Skeleton className="w-28 h-22 rounded-lg" />

                <Skeleton className="w-full h-7 rounded mb-3" />

              </div>
              <Skeleton className="w-full h-6 rounded mb-1" />
              <Skeleton className="w-full h-12 rounded-lg mb-2" />
              <Skeleton className="w-full h-6 rounded mb-1" />
            </div>
          );
        })}
      </ContentContainer>

      <ContentContainer className="hidden md:flex xl:hidden flex-col gap-6">
        {Array.from({ length: 5 }).map((_, index) => {
          return (
            <div key={`branch-near-you-${index}`} className="flex flex-col gap-4 p-6">
              <div className="w-full flex gap-4">
                <Skeleton className="w-28 h-22 rounded-lg" />
                <Skeleton className="w-full h-7 rounded mb-3" />
              </div>
              <div>
                <Skeleton className="w-full h-6 rounded mb-2" />
                <Skeleton className="w-full h-6 rounded" />
              </div>
              <div className="w-full flex gap-2 items-center">
                <Skeleton className="w-4/5 h-12 rounded-lg" />
                <Skeleton className="w-4/5 h-7 rounded-lg" />
              </div>
            </div>
          );
        })}
      </ContentContainer>

      <ContentContainer className="hidden xl:flex flex-col gap-6">
        {Array.from({ length: 5 }).map((_, index) => {
          return (
            <div key={`branch-near-you-${index}`} className="flex gap-4 p-6">
              <div className="w-3/5 flex gap-4">
                <Skeleton className="w-28 h-22 rounded-lg" />
                <div className="flex flex-col w-full">
                  <Skeleton className="w-full h-7 rounded mb-3" />
                  <Skeleton className="w-full h-6 rounded mb-1" />
                  <Skeleton className="w-full h-6 rounded" />
                </div>
              </div>
              <div className="w-2/5 flex flex-col items-end">
                <Skeleton className="w-4/5 h-12 rounded-lg mb-2" />
                <Skeleton className="w-4/5 h-7 rounded-lg" />
              </div>
            </div>
          );
        })}
      </ContentContainer>
    </>
  );
};
